module.exports = __webpack_public_path__ + "static/media/optionsM.ce328336.svg";